<div class="pageWrapper" fxLayout="column">
    @if (accountInitialCopyResources !== PREVIOUSLY_USED_ACCOUNT) {
        <div style="position: relative; left: -75px">
            <app-loading [size]="'50px'" [style]="{'margin-top': '120px'}"></app-loading>
            <div style="text-align: center; margin-top: 5px">
                <span style="font-size: 1.3em">{{ 'general.pleaseWaitInitAccount' | transloco }}</span>
                <br />
                <span style="font-size: 1.3em">{{ 'general.likeTherty' | transloco }}</span>
                <br />
                <br />
                <mat-icon style="position: relative; left: -5px; top: 6px">watch_later</mat-icon>
                <span style="font-size: 1.3em">{{ 'general.totalResourcesDownloaded' | transloco }}
                    : {{ accountInitialCopyResources }}</span>
                <br />
                <br />
                <app-video-link style="display: inline-block;" videoLink="overview"></app-video-link>
                <br />
                <br />
            </div>
        </div>
    }
    @if (accountInitialCopyResources === PREVIOUSLY_USED_ACCOUNT) {
        <!-- Create Scene Button and Statistics Header -->
        <div class="stats-header-wrapper">
            @if (!dialogGetAsset) {
                @if ((groupsAccessTable$ | async).add && dataSource && lastGetTime) {
                    <button color="warn" mat-raised-button
                            (click)="openCreateSceneDialog()" class="create-button">
                        <mat-icon>auto_awesome</mat-icon>&nbsp;
                        <span class="create-button-label">{{ 'general.createScene' | transloco }}</span>
                    </button>
                }
            }

            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <div class="stats-header">
                <div class="stat-card"
                     [class.active]="m_EnumConnectionSelected === m_EnumConnectionType.ALL"
                     (click)="onFilterByCard(m_EnumConnectionType.ALL)">
                    <mat-icon class="stat-icon">apps</mat-icon>
                    <div class="stat-content">
                        <div class="stat-value">{{ getSceneCount() }}</div>
                        <div class="stat-label">total scenes</div>
                    </div>
                    @if (m_EnumConnectionSelected === m_EnumConnectionType.ALL) {
                        <mat-icon class="check-icon">check_circle</mat-icon>
                    }
                </div>
                <div class="stat-card"
                     [class.active]="m_EnumConnectionSelected === m_EnumConnectionType.REGULAR"
                     (click)="onFilterByCard(m_EnumConnectionType.REGULAR)">
                    <mat-icon class="stat-icon">web</mat-icon>
                    <div class="stat-content">
                        <div class="stat-value">{{ getRegularSceneCount() }}</div>
                        <div class="stat-label">regular scenes</div>
                    </div>
                    @if (m_EnumConnectionSelected === m_EnumConnectionType.REGULAR) {
                        <mat-icon class="check-icon">check_circle</mat-icon>
                    }
                </div>
                <div class="stat-card"
                     [class.active]="m_EnumConnectionSelected === m_EnumConnectionType.SPECIALIZED"
                     (click)="onFilterByCard(m_EnumConnectionType.SPECIALIZED)">
                    <mat-icon class="stat-icon">widgets</mat-icon>
                    <div class="stat-content">
                        <div class="stat-value">{{ getSpecializedSceneCount() }}</div>
                        <div class="stat-label">specialized</div>
                    </div>
                    @if (m_EnumConnectionSelected === m_EnumConnectionType.SPECIALIZED) {
                        <mat-icon class="check-icon">check_circle</mat-icon>
                    }
                </div>
                <div class="stat-card"
                     [class.active]="m_EnumConnectionSelected === m_EnumConnectionType.SLIDES"
                     (click)="onFilterByCard(m_EnumConnectionType.SLIDES)">
                    <mat-icon class="stat-icon">touch_app</mat-icon>
                    <div class="stat-content">
                        <div class="stat-value">{{ getSlidesSceneCount() }}</div>
                        <div class="stat-label">slides</div>
                    </div>
                    @if (m_EnumConnectionSelected === m_EnumConnectionType.SLIDES) {
                        <mat-icon class="check-icon">check_circle</mat-icon>
                    }
                </div>
            </div>
            }
        </div>

        <div class="pageHeader">
            <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px">
                    <div fxFlex fxLayoutAlign="start center" fxLayoutGap="16px" class="filter-container">
                        <mat-form-field class="filter-field" appearance="outline">
                            <mat-label>{{ 'placeholder.filterList' | transloco }}</mat-label>
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput inputrestriction="basic1" type="text"
                                    (keyup)="applyFilter($event.target['value'])" name="SearchDualList"
                                    class="form-control"
                                    [(ngModel)]="globalFilter" autocomplete="off" />
                            @if (globalFilter) {
                                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSelection()">
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                        <mat-form-field class="filter-field hide-lt-lg" appearance="outline">
                            <mat-label>{{'placeholder.filterCategory' | transloco}}</mat-label>
                            <mat-icon matPrefix>category</mat-icon>
                            <mat-select [(value)]="columnFilter.tree_path"
                                        (selectionChange)="onCategoryChange($event.value)">
                                <mat-option>{{ 'general.noCategory' | transloco }}</mat-option>
                                @for (category of categories; track category) {
                                    <mat-option [value]="category">
                                        {{ category }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="scene-list-actions">
                            <button mat-icon-button
                                class="favorite-filter-btn"
                                [class.active]="showFavoritesOnly"
                                (click)="onToggleFavoriteFilter()"
                                matTooltip="{{ 'general.favorites' | transloco }}">
                                <mat-icon>{{ showFavoritesOnly ? 'star' : 'star_border' }}</mat-icon>
                            </button>
                            @if (!dialogGetAsset && experienceLevel == experienceLevelType.ADVANCED && trashScenes?.length > 0) {
                                <button mat-icon-button
                                    class="trash-recover-btn"
                                    (click)="openTrashDialog()"
                                    matTooltip="{{ 'ai.trashRecover' | transloco }}">
                                    <mat-icon>settings_backup_restore</mat-icon>
                                    <span class="trash-count-badge">{{ trashScenes?.length || 0 }}</span>
                                </button>
                            }
                            @if (dialogGetAsset && selection?.selected?.length == 1) {
                                <a mat-icon-button (click)="onSelectScene(selection?.selected[0])"
                                   matTooltip="{{'general.selectScene' | transloco}}">
                                    <mat-icon>add</mat-icon>
                                </a>
                            }
                            @if ((groupsAccessTable$ | async).del && selection?.selected?.length > 0) {
                                <a mat-icon-button (click)="onDelete()" matTooltip="{{'general.removeScene' | transloco}}">
                                    <mat-icon>delete</mat-icon>
                                </a>
                            }
                            @if ((groupsAccessTable$ | async).add && selection?.selected?.length == 1) {
                                <a mat-icon-button (click)="confirmDuplicate()"
                                   matTooltip="{{'general.duplicateScene' | transloco}}">
                                    <mat-icon>filter_none</mat-icon>
                                </a>
                            }
                            @if (experienceLevel == experienceLevelType.ADVANCED) {
                                <a mat-icon-button class="hide-lt-sm" (click)="clipboardOpenDialog()"
                                   matTooltip="{{'general.moveScenesBetweenAccounts' | transloco}}">
                                    <mat-icon>merge</mat-icon>
                                </a>
                            }
                        </div>
                    </div>
                </div>
                <div class="d-flex-center wrapButton" style="margin-right: 10px;">
                    <!-- View Toggle Button -->
                    <mat-button-toggle-group [value]="selectedTabIndex"
                                             (change)="onViewToggleChange($event.value)"
                                             class="view-toggle-group">
                        <mat-button-toggle [value]="0">
                            <mat-icon>list</mat-icon>
                            <span class="toggle-label">{{ 'general.list' | transloco }}</span>
                        </mat-button-toggle>
                        <mat-button-toggle [value]="1">
                            <mat-icon>apps</mat-icon>
                            <span class="toggle-label">{{ 'general.grid' | transloco }}</span>
                        </mat-button-toggle>
                    </mat-button-toggle-group>

                    <app-video-link videoLink="sceneList" style="display: inline-block;"></app-video-link>

                    @if (!dialogGetAsset) {
                        <a mat-icon-button class="hide-gt-md" (click)="toggleMinimize.emit();">
                            <mat-icon>settings</mat-icon>
                        </a>
                    }
                </div>
            </div>
        </div>
    }

    @if (accountInitialCopyResources === PREVIOUSLY_USED_ACCOUNT) {
        <mat-tab-group [selectedIndex]="selectedTabIndex" animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start"
                       (selectedTabChange)="toggleListView($event)">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">list</mat-icon>
                    {{ 'general.listView' | transloco }}
                </ng-template>
                <table mat-table class="mat-elevation-z8" [dataSource]="dataSource" matSort
                       (matSortChange)="sortData($event)">
                    @if (!dialogGetAsset || dialogGetAsset.multiSelect) {
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                @if (allowMultiSelect) {
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                                  (click)="$event.stopPropagation()"
                                                  [checked]="selection.hasValue() && isAllSelected()"
                                                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                }
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                              (change)="$event ? selection.toggle(row.Player.$.id) : null"
                                              [checked]="selection.isSelected(row.Player.$.id)">
                                </mat-checkbox>
                            </td>
                        </ng-container>
                    }
                    <ng-container matColumnDef="favorite">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let element" class="favorite-cell">
                            <mat-icon class="favorite-star"
                                [class.is-favorite]="isFavorite(element)"
                                (click)="onFavorite($event, element)">
                                {{ isFavorite(element) ? 'star' : 'star_border' }}
                            </mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="thumbnail">
                        <th mat-header-cell *matHeaderCellDef><span>preview</span></th>
                        <td mat-cell *matCellDef="let element" class="thumbnail-cell">
                            <div class="scene-thumbnail">
                                <app-scene-preview
                                    [setSelectedSceneId]="getPreviewSceneId(element)"
                                    [previewWidth]="60"
                                    [autoScale]="true">
                                </app-scene-preview>
                                @if (element.Player.$.mimeType === 'Json.Slides') {
                                    <div class="scene-badge slides-badge">
                                        <mat-icon>touch_app</mat-icon>
                                    </div>
                                }
                                @if (element.Player?.$?.mimeType?.length > 0 && element.Player.$.mimeType !== 'mainPlayer' && element.Player.$.mimeType !== 'scene' && element.Player.$.mimeType !== 'Json.Slides') {
                                    <div class="scene-badge specialized-badge">
                                        <mat-icon>widgets</mat-icon>
                                    </div>
                                }
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="label">
                        <th mat-header-cell [resizeColumn]="true" mat-sort-header
                            *matHeaderCellDef>{{ 'general.name' | transloco }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="name-cell">
                            <div class="scene-name">{{ element.Player.$.label }}</div>
                            @if (isMobileView) {
                                <div class="mobile-meta">
                                    <span class="mobile-meta-type">
                                        @if (element.Player.$.mimeType.length === 0 || element.Player.$.mimeType === 'mainPlayer') {
                                            Player
                                        } @else if (element.Player.$.mimeType === 'Json.Slides') {
                                            Slides
                                        } @else {
                                            {{ element.Player.$.mimeType | StringJSV2Pipe:stringJSPipeJson | StringJSV2Pipe:stringJSPipeJson2 }}
                                        }
                                    </span>
                                    <span class="mobile-meta-sep"></span>
                                    <span class="mobile-meta-dim">{{ getSceneDimensions(element) }}</span>
                                    <span class="mobile-meta-sep"></span>
                                    <span class="mobile-meta-time">{{ getRelativeTime(element.Player.$?.lastModified) }}</span>
                                </div>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="id">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>id</th>
                        <td mat-cell *matCellDef="let element" class="id-cell">
                            <span class="id-value">{{ element.Player.$.id }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="dimensions">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>size</th>
                        <td mat-cell *matCellDef="let element" class="dimensions-cell">
                            <div class="dimension-badge">
                                <mat-icon>aspect_ratio</mat-icon>
                                <span>{{ getSceneDimensions(element) }}</span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="modified">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.modified' | transloco }}</th>
                        <td mat-cell *matCellDef="let element" class="modified-cell">
                            <div class="time-display">
                                <div class="relative-time">{{ getRelativeTime(element.Player.$?.lastModified) }}</div>
                                <div class="absolute-time">{{ element.Player.$?.lastModified | StringJSV2Pipe:stringJSPipeArgs }}</div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="items">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.items' | transloco }}</th>
                        <td mat-cell *matCellDef="let element" class="items-cell">
                            <div class="items-badge">
                                <mat-icon>layers</mat-icon>
                                <span>{{ getItemCount(element) }}</span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.type' | transloco }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="type-cell">
                            @if (element.Player.$.mimeType.length === 0 || element.Player.$.mimeType === 'mainPlayer') {
                                <div class="type-badge regular-type">
                                    <mat-icon>web</mat-icon>
                                    <span>Player</span>
                                </div>
                            } @else if (element.Player.$.mimeType === 'Json.Slides') {
                                <div class="type-badge slides-type">
                                    <mat-icon>touch_app</mat-icon>
                                    <span>Slides</span>
                                </div>
                            } @else {
                                <div class="type-badge specialized-type">
                                    <mat-icon>widgets</mat-icon>
                                    <span>{{ element.Player.$.mimeType | StringJSV2Pipe:stringJSPipeJson | StringJSV2Pipe:stringJSPipeJson2 }}</span>
                                </div>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="category">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.category' | transloco }}</th>
                        <td mat-cell *matCellDef="let element" class="category-cell">
                            @if (element.Player.$?.folder) {
                                <div class="category-chip">
                                    <mat-icon>folder</mat-icon>
                                    <span>{{ element.Player.$?.folder }}</span>
                                </div>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="playerAssignable">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.playerAssignable2' | transloco }}</th>
                        <td mat-cell *matCellDef="let element" class="assignable-cell">
                            @if (element.Player.$.mimeType.length === 0 || element.Player.$.mimeType === 'mainPlayer') {
                                <fa-icon size="sm" class="assignable-icon" [icon]="faPlugCircleCheck"></fa-icon>
                            }
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row (click)="onSelectedRow(row)" class="table-row"
                        [ngClass]="{'active-row': this.markedRowId == row.Player?.$.id}"
                        tabindex="1" *matRowDef="let row; columns: displayedColumns;">
                    </tr>
                </table>
                @if (!dataSource || !lastGetTime) {
                    <div style="overflow: hidden; height: 250px">
                        <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
                        <br />
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <mat-icon>hourglass_empty</mat-icon>
                            {{ 'placeholder.makeTakeMinute' | transloco }} ...
                        </div>
                    </div>
                }
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">view_module</mat-icon>
                    {{ 'general.thumbnailView' | transloco }}
                </ng-template>
                <ng-template matTabContent>
                    <div fxLayout="row wrap" fxLayoutAlign="flex-start" class="flex-xs-center-center flex-xs-col"
                         style="margin: 10px;">
                        @for (_scene of dataSourcePreviewList$ | async; track _scene; let i = $index) {
                            <div class="preview-thumb fade-in-item"
                                 [style.animation-delay]="(i * 20) + 'ms'"
                                 [ngClass]="{'selected': selection.isSelected($any(_scene.Player.$.id))}"
                                 (click)="$event ? selection.toggle(_scene.Player.$.id) : null">
                                <div class="preview">
                                    <app-scene-preview
                                        [setSelectedSceneId]="getPreviewSceneId(_scene)"
                                        [previewWidth]="190"
                                        [autoScale]="true">
                                    </app-scene-preview>
                                    <!-- <ngx-skeleton-loader
                                    *ngIf="!item.loaded"
                                    animation="progress-dark"
                                    class="preview-loader"
                                                        [theme]="{
                                                            'height': '100%',
                                                            'border-radius': '0',
                                                            'background-color': 'var(--background-color16)'
                                                        }">
                                    </ngx-skeleton-loader> -->
                                </div>
                                <div class="title">{{ _scene.Player.$.label }}</div>
                                @if (!dialogGetAsset) {
                                    <div class="overlay">
                                        <a style="background-color: #0d66c2" mat-icon-button
                                           class="mini-button jump-icon" (click)="onSelectedRow(_scene)"
                                           matTooltip="{{'general.jumpToScene' | transloco}}"
                                           matTooltipPosition="left">
                                            <mat-icon style="color: white">login</mat-icon>
                                        </a>
                                    </div>
                                }
                                @if (dialogGetAsset) {
                                    <div class="overlay">
                                        <a style="background-color: #0d66c2" mat-icon-button
                                           class="mini-button jump-icon" (click)="onSelectedRow(_scene)"
                                           matTooltip="{{'general.selectScene' | transloco}}"
                                           matTooltipPosition="left">
                                            <mat-icon style="color: white">touch / slide</mat-icon>
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    }
    <mat-paginator customPageSize #paginator
                   [pageSize]="pageSize"
                   [pageSizeOptions]="pageSizeOptions"
                   [pageIndex]="pageIndex"
                   [showFirstLastButtons]="true"
                   (page)="onChangePagination($event)"
                   [hidePageSize]="hidePageSize">
    </mat-paginator>
</div>

<ng-template let-modal #addBlackScene>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">add_box</mat-icon>
        <span class="section-title">empty scene</span>
        <button mat-icon-button class="ss-dialog-close-btn" (click)="activeModal.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="styled-dialog-content">
        <div class="form-container">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Scene Name</mat-label>
                <input inputrestriction="basic2" matInput type="text" name="sceneName" autocomplete="off"
                       [(ngModel)]="newSceneSettings.name">
                <mat-icon matSuffix>title</mat-icon>
            </mat-form-field>

            <div class="dimensions-row">
                <mat-form-field appearance="outline" class="form-field dimension-field">
                    <mat-label>Width</mat-label>
                    <input inputrestriction="decimals" matInput type="number" name="sceneWidth" autocomplete="off"
                           [(ngModel)]="newSceneSettings.width">
                    <mat-icon matSuffix>width</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field dimension-field">
                    <mat-label>Height</mat-label>
                    <input inputrestriction="decimals" matInput type="number" name="sceneHeight" autocomplete="off"
                           [(ngModel)]="newSceneSettings.height">
                    <mat-icon matSuffix>height</mat-icon>
                </mat-form-field>
            </div>

            <div class="dialog-actions">
                <button mat-stroked-button (click)="activeModal.close()" class="cancel-btn">
                    <mat-icon>close</mat-icon>
                    Cancel
                </button>
                <button mat-raised-button color="primary" (click)="createBlankScene()" class="create-btn"
                        [disabled]="!newSceneSettings.name || newSceneSettings.width < 100 || newSceneSettings.height < 100">
                    <mat-icon>add_box</mat-icon>
                    {{ 'general.createScene' | transloco }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template let-modal #addSliderModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">touch_app</mat-icon>
        <span class="section-title">
            {{ 'general.createSlides' | transloco }}
        </span>
        <button mat-icon-button class="ss-dialog-close-btn" (click)="activeModal.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="styled-dialog-content">
        <div class="form-container">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Slides Name</mat-label>
                <input inputrestriction="basic2" matInput type="text" name="slidesName" autocomplete="off"
                       [(ngModel)]="newSceneSettings.name">
                <mat-icon matSuffix>slideshow</mat-icon>
            </mat-form-field>

            <div class="slides-config-row">
                <div class="number-of-slides">
                    <app-drop-number-selector
                        label="{{ 'general.numberOfSlides' | transloco }}"
                        [value]="newSceneSettings.slideCount || 3"
                        [min]="1"
                        [max]="10"
                        [presetValues]="[1, 2, 3, 4, 5, 6, 8, 10]"
                        [showManualInput]="true"
                        (valueChange)="onSlideCountChange($event)">
                    </app-drop-number-selector>
                </div>
            </div>

            <div class="dimensions-row">
                <mat-form-field appearance="outline" class="form-field dimension-field">
                    <mat-label>Width</mat-label>
                    <input inputrestriction="decimals" matInput type="number" name="slidesWidth" autocomplete="off"
                           [(ngModel)]="newSceneSettings.width">
                    <mat-icon matSuffix>width</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field dimension-field">
                    <mat-label>Height</mat-label>
                    <input inputrestriction="decimals" matInput type="number" name="slidesHeight" autocomplete="off"
                           [(ngModel)]="newSceneSettings.height">
                    <mat-icon matSuffix>height</mat-icon>
                </mat-form-field>
            </div>

            <div class="dialog-actions">
                <button mat-stroked-button (click)="activeModal.close()" class="cancel-btn">
                    <mat-icon>close</mat-icon>
                    Cancel
                </button>
                <button mat-raised-button color="primary" (click)="createBlankSlider()" class="create-btn"
                        [disabled]="!newSceneSettings.name || newSceneSettings.width < 100 || newSceneSettings.height < 100">
                    <mat-icon>touch_app</mat-icon>
                    {{ 'general.createSlides' | transloco }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template let-modal #firefoxModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">web_asset</mat-icon>
        <span class="section-title">{{ 'general.browserNotice' | transloco }}</span>
        <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content style="height: 100%; background-color: red">
        <div style="width: 100%">
            <fa-icon style="font-size: 4em; color: black" class="faFirefox txtColor" [icon]="faFirefox"></fa-icon>
            <br />
            <br />
            <mat-label style="font-size: 1.4em; color: black">
                {{ 'message.firefoxSucks4' | transloco }}
            </mat-label>
            <mat-label style="font-size: 1.1em; color: black">
                <br />
                <br />
                {{ 'message.firefoxSucks2' | transloco }}
            </mat-label>
        </div>
    </div>
</ng-template>

<ng-template let-modal #createSceneModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">add_circle</mat-icon>
        <span class="section-title">
            {{ 'general.pickSceneType' | transloco }}
        </span>
        <button mat-icon-button class="ss-dialog-close-btn" (click)="activeModal.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="create-scene-dialog-content">
        <div class="scene-options-grid">
            <!-- Row 1: New Empty Scene | Create Slides -->
            <div class="scene-option" (click)="openBlankSceneDialog()">
                <div class="scene-option-icon">
                    <mat-icon>add_box</mat-icon>
                </div>
                <div class="scene-option-header">
                    {{ 'general.newEmptyScene' | transloco }}
                </div>
                <div class="scene-option-description">
                    {{ 'general.createBlank' | transloco }}
                </div>
            </div>

            <div class="scene-option" (click)="openNewSliderDialog()">
                <div class="scene-option-icon">
                    <mat-icon>touch_app</mat-icon>
                </div>
                <div class="scene-option-header">
                    {{ 'general.createSlides' | transloco }}
                </div>
                <div class="scene-option-description">
                    {{ 'general.buildInteractive' | transloco }}
                </div>
            </div>

            <!-- Row 2: Scene Wizard | Create with AI -->
            <div class="scene-option" (click)="addWizard()">
                <div class="scene-option-icon">
                    <mat-icon>auto_fix_high</mat-icon>
                </div>
                <div class="scene-option-header">
                    {{ 'general.sceneWizard' | transloco }}
                </div>
                <div class="scene-option-description">
                    {{ 'general.useWizard' | transloco }}
                </div>
            </div>

            <div class="scene-option" (click)="openAISceneWizard()">
                <div class="scene-option-icon">
                    <mat-icon>auto_awesome</mat-icon>
                </div>
                <div class="scene-option-header">
                    {{ 'ai.createWithAI' | transloco }}
                </div>
                <div class="scene-option-description">
                    {{ 'ai.generateSceneFromPrompt' | transloco }}
                </div>
            </div>

            <!-- Row 3: Import Scene | Template Browser -->
            <div class="scene-option" (click)="addSceneFromTemplate()">
                <div class="scene-option-icon">
                    <mat-icon>star</mat-icon>
                </div>
                <div class="scene-option-header">
                    {{ 'general.importScene' | transloco }}
                </div>
                <div class="scene-option-description">
                    {{ 'general.choosePreBuilt' | transloco }}
                </div>
            </div>

            <div class="scene-option" (click)="openTemplateBrowser()">
                <div class="scene-option-icon">
                    <mat-icon>view_quilt</mat-icon>
                </div>
                <div class="scene-option-header">
                    {{ 'ai.templateBrowser' | transloco }}
                </div>
                <div class="scene-option-description">
                    {{ 'ai.browseTemplates' | transloco }}
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template let-modal #trashModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">settings_backup_restore</mat-icon>
        <span class="section-title">{{ 'ai.trashRecoverTitle' | transloco }}</span>
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="trash-dialog-content">
        <div class="trash-subtitle">
            <mat-icon>auto_delete</mat-icon>
            <div class="trash-subtitle-text">
                <div class="trash-subtitle-title">{{ 'ai.trashRecoverSubtitle' | transloco }}</div>
                <div class="trash-subtitle-info">{{ 'ai.trashInfo' | transloco }}</div>
            </div>
            <div class="trash-count-pill">
                <mat-icon>inventory_2</mat-icon>
                <span>{{ trashScenes?.length || 0 }}</span>
            </div>
        </div>
        @if (!trashScenes?.length) {
            <div class="trash-empty">
                <mat-icon class="trash-empty-icon">delete_outline</mat-icon>
                <div class="trash-empty-label">{{ 'ai.trashEmpty' | transloco }}</div>
            </div>
        }
        @if (trashScenes?.length > 0) {
            <div class="trash-grid-wrapper">
                <div class="trash-grid-header">
                    <div class="trash-col trash-col-icon"></div>
                    <div class="trash-col trash-col-name">{{ 'general.name' | transloco }}</div>
                    <div class="trash-col trash-col-size">{{ 'general.size' | transloco }}</div>
                    <div class="trash-col trash-col-modified">{{ 'general.modified' | transloco }}</div>
                    <div class="trash-col trash-col-action"></div>
                </div>
                <div class="trash-grid-rows">
                    @for (_scene of trashScenes; track _scene?.Player?.$?.id; let i = $index) {
                        <div class="trash-grid-row fade-in-item" [style.animation-delay]="(i * 30) + 'ms'">
                            <div class="trash-col trash-col-icon">
                                <div class="trash-row-icon">
                                    <mat-icon>delete</mat-icon>
                                </div>
                            </div>
                            <div class="trash-col trash-col-name">
                                <div class="trash-row-name" matTooltip="{{ _scene?.Player?.$?.label }}">{{ _scene?.Player?.$?.label }}</div>
                                <div class="trash-row-id">id {{ _scene?.Player?.$?.id }}</div>
                            </div>
                            <div class="trash-col trash-col-size">
                                <span class="trash-chip">
                                    <mat-icon>aspect_ratio</mat-icon>
                                    <span>{{ getTrashSceneDimensions(_scene) }}</span>
                                </span>
                            </div>
                            <div class="trash-col trash-col-modified">
                                <span class="trash-chip">
                                    <mat-icon>schedule</mat-icon>
                                    <span>{{ getRelativeTime(_scene?.Player?.$?.lastModified) }}</span>
                                </span>
                            </div>
                            <div class="trash-col trash-col-action">
                                <button mat-raised-button color="warn" class="trash-restore-btn" (click)="restoreTrashedScene(_scene)">
                                    <mat-icon>restore</mat-icon>
                                    <span>{{ 'ai.trashRestore' | transloco }}</span>
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</ng-template>

